(() => {
  document.documentElement.classList.add("hp-js");
  function fmtRange(now, start, end, locale) {
    const day = (n) =>
        new Date(now.getFullYear(), now.getMonth(), now.getDate() + n, 12),
      a = day(start),
      b = day(Math.max(start, end)),
      opts = { month: "short", day: "numeric" };
    b.getFullYear() !== now.getFullYear() && (opts.year = "numeric");
    const f = new Intl.DateTimeFormat(locale, opts);
    return {
      a,
      b,
      text:
        start === end
          ? f.format(a)
          : f.formatRange
            ? f.formatRange(a, b)
            : f.format(a) + "\u2013" + f.format(b),
    };
  }
  let shipTimer;
  function updateShipDates() {
    clearTimeout(shipTimer);
    const now = new Date(),
      loc = document.documentElement.lang || "en-US";
    document.querySelectorAll("[data-hp-ship-date]").forEach((el) => {
      const s = Number(el.dataset.start),
        e = Number(el.dataset.end);
      if (!Number.isFinite(s) || !Number.isFinite(e)) return;
      const r = fmtRange(now, s, e, loc);
      el.textContent = r.text;
      const full = new Intl.DateTimeFormat(loc, { dateStyle: "long" });
      el.setAttribute(
        "aria-label",
        s === e
          ? full.format(r.a)
          : full.format(r.a) + " to " + full.format(r.b),
      );
    });
    const midnight = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() + 1,
    );
    shipTimer = setTimeout(updateShipDates, midnight - now + 200);
  }
  window.addEventListener("pageshow", updateShipDates),
    document.addEventListener("visibilitychange", () => {
      document.hidden || updateShipDates();
    });
  const Gift = (() => {
    let cfg = null,
      pending = null;
    const base = () => window.Shopify?.routes?.root || "/";
    async function req(path, body, tries = 2) {
      const r = await fetch(
        base() + path,
        body
          ? {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify(body),
            }
          : { headers: { Accept: "application/json" } },
      );
      let d;
      try {
        d = JSON.parse(await r.text());
      } catch {
        if (tries > 1)
          return (
            await new Promise((z) => setTimeout(z, 500)),
            req(path, body, tries - 1)
          );
        throw Error("Your bag is busy. Please try again in a moment.");
      }
      if (!r.ok || d.status)
        throw Error(
          d.description ||
            d.message ||
            "Your bag could not be updated. Please try again.",
        );
      return d;
    }
    async function reconcile() {
      if (!cfg || !cfg.gift) return null;
      let cart = await req("cart.js");
      const isPack = (i) => cfg.packs.includes(Number(i.variant_id)),
        gifts = cart.items.filter((i) => Number(i.variant_id) === cfg.gift),
        want = cart.items.some(isPack) ? 1 : 0,
        have = gifts.reduce((n, i) => n + i.quantity, 0),
        codes = (cart.discount_codes || []).map((d) => d.code),
        own = cfg.code.toUpperCase(),
        others = codes.filter((c) => c.toUpperCase() !== own),
        applied = codes.some((c) => c.toUpperCase() === own),
        free = gifts.every((i) => i.final_line_price === 0);
      if (have === want && (want === 0 ? !applied : applied && free))
        return cart;
      const updates = {};
      gifts.length
        ? gifts.forEach((g, k) => (updates[g.key] = k === 0 ? want : 0))
        : want && (updates[cfg.gift] = want);
      const drawer = document.querySelector("cart-drawer"),
        sections = drawer?.getSectionsToRender?.().map((s) => s.id) || [];
      cart = await req("cart/update.js", {
        updates,
        discount: [...others, ...(want ? [cfg.code] : [])].join(","),
        sections,
        sections_url: location.pathname,
      });
      const charged = cart.items.filter(
        (i) => Number(i.variant_id) === cfg.gift && i.final_line_price > 0,
      );
      if (want && charged.length) {
        const rm = {};
        throw (
          (charged.forEach((i) => (rm[i.key] = 0)),
          (cart = await req("cart/update.js", {
            updates: rm,
            sections,
            sections_url: location.pathname,
          })),
          drawer?.renderContents &&
            cart.sections &&
            drawer.renderContents({ id: cfg.gift, sections: cart.sections }),
          Error(
            "HoloPop is in your bag, but the free Wrap & Share Set could not be applied. Please contact us before checkout.",
          ))
        );
      }
      return (
        drawer?.renderContents &&
          cart.sections &&
          drawer.renderContents({ id: cfg.gift, sections: cart.sections }),
        cart
      );
    }
    return {
      set(c) {
        cfg = c;
      },
      sync() {
        return (
          pending ||
          ((pending = reconcile().finally(() => (pending = null))), pending)
        );
      },
    };
  })();
  window.HoloPopGift = Gift;
  const init = () => {
    updateShipDates();
    const secs = document.querySelectorAll(".hp-s[data-hp-reveal]");
    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver(
        (es) =>
          es.forEach((e) => {
            e.isIntersecting &&
              (e.target.classList.add("is-in"), io.unobserve(e.target));
          }),
        { threshold: 0, rootMargin: "0px 0px -10% 0px" },
      );
      secs.forEach((s) => io.observe(s));
    } else secs.forEach((s) => s.classList.add("is-in"));
    const root = document.querySelector("#holopop");
    if (!root || root.dataset.ready) return;
    root.dataset.ready = "1";
    const buyBox = root.querySelector(".hp-buy");
    buyBox &&
      !matchMedia("(prefers-reduced-motion:reduce)").matches &&
      (buyBox.classList.add("hp-pre"),
      requestAnimationFrame(() =>
        requestAnimationFrame(() => buyBox.classList.remove("hp-pre")),
      ));
    const money = (c) =>
        new Intl.NumberFormat(document.documentElement.lang || "en-US", {
          style: "currency",
          currency: root.dataset.currency || "USD",
        }).format(c / 100),
      tiers = [...root.querySelectorAll('[name="hp-tier"]')],
      tierInfo = (t) => {
        const r = tiers.find((x) => x.value === String(t)) || tiers[0];
        return {
          r,
          variant: Number(r.dataset.variant),
          price: Number(r.dataset.price),
          compare: Number(r.dataset.compare || 0),
          available: r.dataset.available === "true",
        };
      };
    Gift.set({
      packs: tiers.map((r) => Number(r.dataset.variant)),
      gift: Number(root.dataset.giftVariant) || 0,
      code: root.dataset.giftCode || "HOLOPOPGIFT",
    });
    const g = root.querySelector("[data-hp-gallery]"),
      slides = [...g.querySelectorAll(".hp-slide")],
      thumbs = [...root.querySelectorAll(".hp-thumb")],
      smooth = () =>
        matchMedia("(prefers-reduced-motion:reduce)").matches
          ? "auto"
          : "smooth",
      idx = () => Math.round(g.scrollLeft / g.clientWidth),
      to = (i) =>
        g.scrollTo({
          left: Math.max(0, Math.min(slides.length - 1, i)) * g.clientWidth,
          behavior: smooth(),
        });
    root
      .querySelectorAll("[data-hp-slide]")
      .forEach((b) =>
        b.addEventListener("click", () => to(Number(b.dataset.hpSlide))),
      ),
      root
        .querySelector("[data-hp-next]")
        .addEventListener("click", () => to(idx() + 1)),
      root
        .querySelector("[data-hp-prev]")
        .addEventListener("click", () => to(idx() - 1));
    let raf;
    g.addEventListener(
      "scroll",
      () => {
        cancelAnimationFrame(raf),
          (raf = requestAnimationFrame(() => {
            const i = idx();
            (root.querySelector("[data-hp-index]").textContent = String(i + 1)),
              thumbs.forEach((t, j) => {
                t.classList.toggle("is-on", i === j),
                  t.setAttribute("aria-pressed", String(i === j));
              });
            const strip = thumbs[0] && thumbs[0].parentElement,
              on = thumbs[i];
            strip &&
              on &&
              strip.scrollWidth > strip.clientWidth &&
              strip.scrollTo({
                left: on.offsetLeft - strip.offsetLeft - (strip.clientWidth - on.offsetWidth) / 2,
                behavior: smooth(),
              });
          }));
      },
      { passive: !0 },
    ),
      g.addEventListener("keydown", (e) => {
        (e.key === "ArrowRight" || e.key === "ArrowLeft") &&
          (e.preventDefault(), to(idx() + (e.key === "ArrowRight" ? 1 : -1)));
      });
    let tier = Number(root.dataset.tier) || 1;
    const termsId = root.querySelector("[data-hp-terms-id]"),
      paint = () => {
        const t = tierInfo(tier);
        tiers.forEach((r) => {
          (r.checked = r.value === String(tier)),
            r.closest(".hp-offer").classList.toggle("is-on", r.checked);
        }),
          (root.querySelector("[data-hp-price]").textContent = money(t.price));
        const c = root.querySelector("[data-hp-compare]"),
          s = root.querySelector("[data-hp-save]");
        c &&
          s &&
          (t.compare > t.price
            ? ((c.hidden = !1),
              (s.hidden = !1),
              (c.textContent = money(t.compare)),
              (s.textContent =
                "Save " +
                money(t.compare - t.price).replace(/\.00(?=\D*$)/, "")))
            : ((c.hidden = !0), (s.hidden = !0))),
          document
            .querySelectorAll("[data-hp-atc-total]")
            .forEach((el) => (el.textContent = money(t.price)));
        const sp = document.querySelector("[data-hp-sticky-price]");
        sp && (sp.textContent = money(t.price)),
          document.querySelectorAll("[data-hp-tier-amount]").forEach((el) => {
            el.textContent = money(
              tierInfo(Number(el.dataset.hpTierAmount)).price,
            );
          }),
          termsId &&
            termsId.value !== String(t.variant) &&
            ((termsId.value = t.variant),
            termsId.dispatchEvent(new Event("change", { bubbles: !0 })));
        const lbl = root.querySelector("[data-hp-add-label]"),
          main = root.querySelector(".hp-atc[data-hp-add]");
        main &&
          ((main.disabled = !t.available),
          lbl &&
            (lbl.textContent = t.available
              ? main.dataset.label || lbl.textContent
              : "Sold out"));
        const u = new URL(location.href);
        u.searchParams.set("variant", t.variant),
          history.replaceState(history.state, "", u);
      },
      mainLbl = root.querySelector("[data-hp-add-label]");
    mainLbl &&
      (root.querySelector(".hp-atc[data-hp-add]").dataset.label =
        mainLbl.textContent),
      tiers.forEach((r) =>
        r.addEventListener("change", () => {
          (tier = Number(r.value)), paint();
        }),
      ),
      paint(),
      window.addEventListener("pageshow", paint);
    async function drawerReady() {
      await customElements.whenDefined("cart-drawer");
      const d = document.querySelector("cart-drawer");
      if (!d || typeof d.renderContents != "function")
        throw Error("The bag is still loading. Please try again.");
      return d;
    }
    const setCount = (n) =>
        root
          .querySelectorAll("[data-hp-count]")
          .forEach((e) => (e.textContent = n)),
      vipFirst = () => {
        const sheet = document.querySelector(".vf-root"),
          bag = document.querySelector("cart-drawer");
        if (!sheet || !bag || sheet.classList.contains("open")) return;
        const hide = {
          visibility: "hidden",
          opacity: "0",
          "pointer-events": "none",
          transition: "none",
        };
        Object.keys(hide).forEach((p) =>
          bag.style.setProperty(p, hide[p], "important"),
        );
        let ticks = 0;
        const tm = setInterval(() => {
          (sheet.classList.contains("open") || ++ticks >= 15) &&
            (clearInterval(tm),
            Object.keys(hide).forEach((p) => bag.style.removeProperty(p)));
        }, 100);
      };
    let busy = !1;
    async function add(e) {
      if (busy) return;
      const btn = e.currentTarget;
      btn.dataset.hpTier && ((tier = Number(btn.dataset.hpTier)), paint());
      const t = tierInfo(tier);
      if (!t.available) return;
      busy = !0;
      const buttons = [...document.querySelectorAll("[data-hp-add]")];
      buttons.forEach((b) => {
        (b.disabled = !0), b.setAttribute("aria-busy", "true");
      });
      const err = root.querySelector("[data-hp-error]");
      err.textContent = "";
      try {
        const drawer = await drawerReady();
        drawer.setActiveElement && drawer.setActiveElement(btn);
        const sections = drawer.getSectionsToRender().map((s) => s.id),
          res = await fetch(window.routes?.cart_add_url || "/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              items: [{ id: t.variant, quantity: 1 }],
              sections,
              sections_url: location.pathname,
            }),
          });
        let data;
        try {
          data = JSON.parse(await res.text());
        } catch {
          throw Error("HoloPop could not be added. Please try again.");
        }
        if (!res.ok || data.status)
          throw Error(
            data.description ||
              data.message ||
              "HoloPop could not be added. Please try again.",
          );
        vipFirst(), drawer.renderContents(data);
        let cart;
        try {
          cart = await Gift.sync();
        } catch (ge) {
          err.textContent = ge.message;
        }
        cart ||
          (cart = await fetch(
            (window.Shopify?.routes?.root || "/") + "cart.js",
            { headers: { Accept: "application/json" } },
          ).then((r) => r.json())),
          setCount(cart.item_count),
          drawer.classList.toggle("is-empty", cart.item_count === 0),
          drawer.open(btn);
      } catch (x) {
        (err.textContent =
          x.message || "Please check your bag before trying again."),
          err.scrollIntoView({ block: "center", behavior: smooth() });
      } finally {
        (busy = !1),
          buttons.forEach((b) => {
            b.removeAttribute("aria-busy"), (b.disabled = !1);
          }),
          paint();
      }
    }
    document
      .querySelectorAll("[data-hp-add]")
      .forEach((b) => b.addEventListener("click", add)),
      root.querySelectorAll("[data-hp-cart]").forEach((b) =>
        b.addEventListener("click", async () => {
          try {
            const d = await drawerReady();
            await Gift.sync();
            const ids = d.getSectionsToRender().map((s) => s.id),
              base = window.Shopify?.routes?.root || "/",
              [sections, c] = await Promise.all([
                fetch(base + "?sections=" + ids.join(",")).then((r) =>
                  r.json(),
                ),
                fetch(base + "cart.js").then((r) => r.json()),
              ]);
            d.renderContents({ id: 0, sections }),
              d.classList.toggle("is-empty", c.item_count === 0),
              setCount(c.item_count),
              d.open(b);
          } catch (x) {
            root.querySelector("[data-hp-error]").textContent = x.message;
          }
        }),
      ),
      typeof subscribe == "function" &&
        typeof PUB_SUB_EVENTS < "u" &&
        subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
          clearTimeout(window.__hpSync),
            (window.__hpSync = setTimeout(
              () =>
                Gift.sync()
                  .then((c) => c && setCount(c.item_count))
                  .catch((x) => {
                    const e =
                      document.querySelector("#CartDrawer-CartErrors") ||
                      root.querySelector("[data-hp-error]");
                    e && (e.textContent = x.message);
                  }),
              150,
            ));
        });
    const nd = document.querySelector("cart-drawer");
    nd &&
      new MutationObserver(() => {
        const q = [
          ...nd.querySelectorAll(".cart-drawer-item .quantity__input"),
        ];
        q.length
          ? setCount(q.reduce((n, i) => n + Number(i.value || 0), 0))
          : nd.classList.contains("is-empty") && setCount(0);
      }).observe(nd, { subtree: !0, childList: !0 }),
      document.addEventListener(
        "click",
        (e) => {
          const b = e.target.closest(
            'cart-drawer [name="checkout"],cart-drawer a[href$="/checkout"]',
          );
          !b ||
            b.dataset.hpReady === "1" ||
            (e.preventDefault(),
            e.stopImmediatePropagation(),
            Gift.sync()
              .then(() => {
                const n =
                  document.querySelector('cart-drawer [name="checkout"]') || b;
                (n.dataset.hpReady = "1"), n.click(), delete n.dataset.hpReady;
              })
              .catch((x) => {
                const el =
                  document.querySelector("#CartDrawer-CartErrors") ||
                  root.querySelector("[data-hp-error]");
                el && (el.textContent = x.message);
              }));
        },
        !0,
      ),
      Gift.sync()
        .then((c) => c && setCount(c.item_count))
        .catch(() => {});
    const dlg = document.querySelector("#holopop-policy");
    dlg &&
      (document
        .querySelectorAll("[data-hp-policy]")
        .forEach((b) => b.addEventListener("click", () => dlg.showModal())),
      dlg
        .querySelector("[data-hp-close]")
        .addEventListener("click", () => dlg.close()),
      dlg.addEventListener("click", (e) => {
        e.target === dlg && dlg.close();
      }));
    const cBan = document.querySelector(".hp-banner"),
      cPill = document.querySelector(".hp-concept-pill");
    cPill &&
      (cBan && "IntersectionObserver" in window
        ? new IntersectionObserver((es) =>
            cPill.classList.toggle("is-on", !es[0].isIntersecting),
          ).observe(cBan)
        : cPill.classList.add("is-on"));
    const sticky = document.querySelector("[data-hp-sticky]"),
      buy = root.querySelector(".hp-buy .hp-atc");
    sticky &&
      buy &&
      new IntersectionObserver((es) => {
        const show = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
        sticky.classList.toggle("is-on", show),
          sticky.setAttribute("aria-hidden", String(!show)),
          (sticky.querySelector("button").tabIndex = show ? 0 : -1);
      }).observe(buy);
  };
  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", init)
    : init(),
    document.addEventListener("shopify:section:load", () => {
      updateShipDates(),
        document
          .querySelectorAll(".hp-s[data-hp-reveal]")
          .forEach((s) => s.classList.add("is-in"));
    });
})();

/* HoloPop light demo: moving the light shifts the rainbow on the etched hearts */
(() => {
  const setup = () => {
    document.querySelectorAll("[data-hp-demo]").forEach((d) => {
      if (d.dataset.ready) return;
      d.dataset.ready = "1";
      const stage = d.querySelector("[data-hp-demo-stage]");
      const range = d.querySelector("[data-hp-light]");
      if (!stage) return;
      let val = range ? Number(range.value) / 100 : 0.3;
      let touched = false;
      const set = (v) => {
        val = Math.max(0, Math.min(1, v));
        const wave = Math.sin(val * Math.PI);
        stage.style.setProperty("--hp-h", (val * 320 - 70).toFixed(1) + "deg");
        stage.style.setProperty("--hp-o", (0.4 + 0.6 * Math.abs(Math.sin(val * Math.PI * 1.5 + 0.4))).toFixed(3));
        stage.style.setProperty("--hp-b", (0.95 + 0.3 * wave).toFixed(3));
        stage.style.setProperty("--hp-x", (val * 240 - 20).toFixed(1) + "%");
        if (range && document.activeElement !== range) range.value = String(Math.round(val * 100));
      };
      set(val);
      range && range.addEventListener("input", () => { touched = true; set(Number(range.value) / 100); });
      const fromPointer = (e) => {
        const r = stage.getBoundingClientRect();
        set((e.clientX - r.left) / r.width);
      };
      stage.addEventListener("pointermove", (e) => { if (e.pointerType === "mouse" || e.buttons) { touched = true; fromPointer(e); } });
      stage.addEventListener("pointerdown", (e) => {
        touched = true;
        fromPointer(e);
        const D = window.DeviceOrientationEvent;
        if (D && typeof D.requestPermission === "function" && !d.dataset.orient) {
          d.dataset.orient = "1";
          D.requestPermission().then((s) => s === "granted" && listenTilt()).catch(() => {});
        }
      });
      let tiltOn = false;
      const listenTilt = () => {
        if (tiltOn) return;
        tiltOn = true;
        window.addEventListener("deviceorientation", (e) => {
          if (e.gamma == null) return;
          const r = stage.getBoundingClientRect();
          if (r.bottom < 0 || r.top > innerHeight) return;
          touched = true;
          set((e.gamma + 30) / 60);
        }, { passive: true });
      };
      const D = window.DeviceOrientationEvent;
      if (D && typeof D.requestPermission !== "function" && matchMedia("(pointer: coarse)").matches) listenTilt();
      // until the visitor takes over, the light follows the scroll
      let raf;
      const onScroll = () => {
        if (touched) return;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const r = stage.getBoundingClientRect();
          if (r.bottom < 0 || r.top > innerHeight) return;
          set(1 - (r.top + r.height) / (innerHeight + r.height));
        });
      };
      addEventListener("scroll", onScroll, { passive: true });
      onScroll();
    });
  };
  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", setup) : setup();
  document.addEventListener("shopify:section:load", setup);
})();
